import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { SCRAPED_PRODUCT_KEY } from "./keys";

import { ScrapedProductRepository } from "@/repositories/scraped-product";

export const useDisassociateScrapedProduct = () => {
  const scrapedProductRepository = useRef(new ScrapedProductRepository());
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (scrapedProductIds: string[]) => {
      return await scrapedProductRepository.current.disassociate(
        scrapedProductIds,
      );
    },
    onSuccess: () => {
      queryClient.refetchQueries({
        predicate: (q) => {
          if (q.queryKey[0] === SCRAPED_PRODUCT_KEY) {
            return true;
          }

          return false;
        },
      });
    },
  });
};
